"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = void 0;
var react_1 = __importDefault(require("react"));
var Error_styles_1 = require("./Error.styles");
/*
 This is a generic error component that can be used to display error messages in forms or elsewhere in the webapp.

 There is an optional error icon which is an exclamtion mark in a circle ([Alert](https://www.figma.com/design/v2Updirews5bBoa1whnzzj/%F0%9F%8C%90-Iconography?node-id=427-4887&m=dev) icon).
*/
var Error = function (_a) {
    var errorText = _a.errorText, _b = _a.size, size = _b === void 0 ? 'small' : _b, _c = _a.showIcon, showIcon = _c === void 0 ? false : _c, className = _a.className;
    return (react_1.default.createElement(Error_styles_1.ErrorContainer, { className: className },
        showIcon && react_1.default.createElement(Error_styles_1.ErrorIcon, null),
        react_1.default.createElement(Error_styles_1.ErrorText, { "$size": size }, errorText)));
};
exports.Error = Error;
